import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { i18nInitPromise } from './i18n';

const rootElement = document.getElementById('root');

/**
 * Wait for i18next to finish loading every translation namespace before ever
 * mounting/hydrating. Without this, hydrateRoot ran immediately while
 * translations were still loading, so the client's first render didn't match
 * the fully-translated prerendered HTML - a hydration mismatch risk on every
 * page. See the comment on ALL_NAMESPACES in ./i18n.js for the full
 * explanation. .finally() (not .then()) so the app still renders even if
 * i18next's initial load ever fails for some reason, rather than hanging on
 * a blank page.
 */
i18nInitPromise.finally(() => {
    if (rootElement.hasChildNodes()) {
        ReactDOM.hydrateRoot(
            rootElement,
            <React.StrictMode>
                <App />
            </React.StrictMode>,
        );
    } else {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>,
        );
    }
});

reportWebVitals();
